import {
  PeopleTableInfo,
  Person,
  PersonCompanyGeneralInfo,
  PersonContactDetailsItem,
} from '@aibees/elephant/feature/search-table-people/types';
import { ROUTES as R } from '@aibees/elephant/router';
import { ENRICHMENT_STATE } from '@aibees/elephant/types';
import { Nullable } from '@aibees/shared/definition';
import { fDate, fToNow } from '@aibees/shared/utils';
import { ContactDetailsSliderTabTitle } from './types';

export function doesContactDetailHaveUpdate(
  item: PersonContactDetailsItem,
  data?: PeopleTableInfo
) {
  return !!data?.changes?.CONTACT?.includes(item);
}

export function doesContactDetailHaveAnyUpdates(data?: PeopleTableInfo) {
  return !!data?.changes?.CONTACT?.length;
}

export function profileDetailsLatestUpdateDate(data?: PeopleTableInfo) {
  return fToNow(data?.revelation?.contact?.created);
}

export function getContactDetailsCompanyLink(
  item?: Nullable<PersonCompanyGeneralInfo>
) {
  const id = item?.id;
  return id && R.company.replace(':id', id);
}

export function formattedContactDetailsDate(date?: Nullable<string>) {
  return fDate(date, 'yyyy');
}

export function formattedStartToEndDuration(
  start?: Nullable<string>,
  end?: Nullable<string>
) {
  return `${formattedContactDetailsDate(start)} - ${
    !end ? 'Present' : formattedContactDetailsDate(end)
  }`;
}

export function contactDetailsAvailableItems(data?: PeopleTableInfo) {
  return data?.revelation?.contact?.content ?? data?.available ?? [];
}

export function contactDetailsUnlockableItems(data?: PeopleTableInfo) {
  const available = contactDetailsAvailableItems(data);
  const hasJobChange = isJobChangeHappened(data);
  return available.filter(
    (i) =>
      (i !== PersonContactDetailsItem.EXPERIENCE || hasJobChange) &&
      i !== PersonContactDetailsItem.LANGUAGES
  );
}

export function isRefetchNeededAfterRevealContactDetails(data?: Person) {
  let response = false;
  if (data?.revelation?.contact?.state === ENRICHMENT_STATE.SUCCESS) {
    data.revelation.contact.content?.map((item) => {
      switch (item) {
        case PersonContactDetailsItem.EXPERIENCE:
          if (!data?.positionGroups) response = true;
          break;
        case PersonContactDetailsItem.PUBLICATIONS:
          if (!data?.publications?.length) response = true;
          break;
        case PersonContactDetailsItem.VOLUNTEER_EXPERIENCES:
          if (!data?.volunteerExperiences?.length) response = true;
          break;
        case PersonContactDetailsItem.CERTIFICATIONS:
          if (!data?.certifications?.length) response = true;
          break;
        case PersonContactDetailsItem.PROJECTS:
          if (!data?.projects?.length) response = true;
          break;
        case PersonContactDetailsItem.EDUCATIONS:
          if (!data?.educations?.length) response = true;
          break;
        // TODO: this case will change when-ever the back-end API is ready
        // case PersonContactDetailsItem.RECOMMENDATION:
        //   return false;
        case PersonContactDetailsItem.LANGUAGES:
          if (!data?.languages?.profile_languages?.length) response = true;
          break;
        default:
          break;
      }
    });
  }
  return response;
}

export function isJobChangeHappened(data?: PeopleTableInfo) {
  if (!data?.changes?.CONTACT?.length) return false;

  if (data.changes.CONTACT.includes(PersonContactDetailsItem.EXPERIENCE))
    return true;

  return false;
}

export function showProfileInsightItemTabBadge(
  locked: boolean,
  key: ContactDetailsSliderTabTitle,
  hasJobChange: boolean,
  loading: boolean,
  hasUpdate: boolean
) {
  return (
    locked ||
    (key === ContactDetailsSliderTabTitle.Work_History && hasJobChange) ||
    loading ||
    hasUpdate
  );
}
